import React from 'react';
import styles from './JobseekerProfileEmployerViewBody.module.css';
import { useTranslation } from 'react-i18next';

function RoleBasedSkills({ jobseeker, ref }) {
    const { t } = useTranslation();
    
    return (
        <div ref={ref} id="roleSkills" className={styles.overViewContainer}>
            <h2 className={`${styles.heading} ${styles.removeMarginBottom}`}>
                {t('overview.roleBasedSkills')}
            </h2>
            {jobseeker?.roleSkills && jobseeker.roleSkills.length > 0 ? (
                jobseeker.roleSkills.map((roleSkill, index) => (
                    <div key={index} className={styles.roleSkillContainer}>
                        <h3 className={styles.title}>
                            {t('general.language') === 'en' ? roleSkill.role_name_en : roleSkill.role_name_ar}
                        </h3>
                        <div>
                            {roleSkill.skills && roleSkill.skills.map((skill, skillIndex) => (
                                <span key={skillIndex} className={styles.skillChip}>
                                    {skill}
                                </span>
                            ))}
                        </div>
                    </div>
                ))
            ) : (
                <p className={styles.description}>{t('overview.noRoleSkills')}</p>
            )}
        </div>
    );
}

export default RoleBasedSkills; 